<!-- Card -->
<div class="header-card card">
  <div class="header-banner">
    <div class="avatar-wrap">
      <img [src]="getUserImage(user?.pictureUrl)" [alt]="user?.name" class="avatar" />
    </div>
  </div>

  <div class="header-body">
    <div class="header-info">
      <h1 class="name">{{ user?.name }}</h1>
      <p class="title">{{ user?.specialization }}</p>
      <p class="location">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
        {{ getUserLocation(user?.city, user?.country) }}
      </p>
    </div>

    <div class="header-actions" *ngIf="mode=='edit'">
      <button class="btn btn-outline" (click)="openEditModal()">{{ 'profileHeader.editProfile' | translate }}</button>
      <button class="btn btn-upload" (click)="openEditModal()">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
        {{ 'profileHeader.uploadCV' | translate }}
      </button>
    </div>
    <div class="header-actions" *ngIf="mode=='view'">

      <button class="btn btn-upload" *ngIf="user?.cvUrl" (click)="downloadCv()">
        <i class="bi bi-download"></i> {{ 'profileHeader.downloadCV' | translate }}
      </button>
    </div>
  </div>

  <div class="divider"></div>

  <div class="badges-row">
    <!-- collarType -->
    <button *ngIf="user?.openToWork" class="badge badge-green">{{ 'profileHeader.openToWork' | translate }}</button>
    <button *ngIf="user?.collarType" class="badge badge-blue">{{user?.collarType}}</button>
  </div>
</div>


<div class="modal-overlay" *ngIf="isEditModalOpen" (click)="closeEditModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">

    <button class="close-btn" (click)="closeEditModal()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="modal-header-banner"></div>

    <div class="modal-body">

      <div class="image-section">
        <div class="image-wrapper">
          <img [src]="previewImage || getUserImage(user?.pictureUrl)" [alt]="user?.name" class="profile-image"
            (click)="imageInput.click()" />
          <div class="image-overlay" (click)="imageInput.click()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
              <circle cx="12" cy="13" r="4"></circle>
            </svg>
          </div>
        </div>
        <input #imageInput type="file" hidden accept="image/*" (change)="onImageSelect($event)" />
      </div>

      <form [formGroup]="profileForm">

        <div class="form-row">
          <div class="form-group">
            <label for="name">{{ 'profileHeader.name' | translate }}</label>
            <input id="name" type="text" formControlName="name" class="form-input" placeholder="Full Name" />
          </div>
          <div class="form-group">
            <label for="specialization">{{ 'profileHeader.specialization' | translate }}</label>
            <input id="specialization" type="text" formControlName="specialization" class="form-input"
              placeholder="Job Title" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="city">{{ 'profileHeader.city' | translate }}</label>
            <input id="city" type="text" formControlName="city" class="form-input" placeholder="City" />
          </div>
          <div class="form-group">
            <label for="country">{{ 'profileHeader.country' | translate }}</label>
            <input id="country" type="text" formControlName="country" class="form-input" placeholder="Country" />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="email">{{ 'profileHeader.email' | translate }}</label>
            <input id="email" type="email" formControlName="email" class="form-input" placeholder="Email Address" />
          </div>
          <div class="form-group">
            <label for="phoneNumber">{{ 'profileHeader.phone' | translate }}</label>
            <input id="phoneNumber" type="tel" formControlName="phoneNumber" class="form-input"
              placeholder="Phone Number" />
          </div>
        </div>

        <div class="form-group full-width">
          <label for="lnkd">{{ 'profileHeader.linkedIn' | translate }}</label>
          <input id="lnkd" type="text" formControlName="linkedInLink" class="form-input"
            placeholder="https://linkedin.com/in/yourname" />
        </div>

        <div class="form-group full-width">
          <label>{{ 'profileHeader.cvResume' | translate }}</label>
          <div class="cv-section">

            <div class="cv-display" *ngIf="user?.cvUrl && !newCvFile">
              <div class="cv-info">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                  <polyline points="13 2 13 9 20 9"></polyline>
                </svg>
                <span>{{ 'profileHeader.currentCVUploaded' | translate }}</span>
              </div>
              <button type="button" class="btn-change" (click)="cvInput.click()">
                {{ 'profileHeader.change' | translate }}
              </button>
            </div>

            <div class="cv-upload" *ngIf="!user?.cvUrl && !newCvFile">
              <div class="upload-area" (click)="cvInput.click()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <p><strong>{{ 'profileHeader.clickToUploadOrDragAndDrop' | translate }}</strong></p>
                <span>{{ 'profileHeader.pdfDocDocxMax5MB' | translate }}</span>
              </div>
            </div>

            <input #cvInput type="file" hidden accept=".pdf,.doc,.docx" (change)="onCvSelect($event)" />

            <div class="cv-selected" *ngIf="newCvFile">
              <div class="file-info">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                  <polyline points="13 2 13 9 20 9"></polyline>
                </svg>
                <div>
                  <p class="filename">{{ newCvFile.name }}</p>
                  <p class="filesize">{{ (newCvFile.size / 1024).toFixed(2) }} KB</p>
                </div>
              </div>
              <button type="button" class="btn-remove" (click)="removeCv()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

          </div>
        </div>

        <!-- Open to Work -->
        <div class="open-to-work-row">
          <span class="otw-label">{{ 'profileHeader.openToWork' | translate }}</span>
          <label class="toggle-switch">
            <input type="checkbox" formControlName="openToWork" class="toggle-input" />
            <span class="toggle-track">
              <span class="toggle-thumb"></span>
            </span>
          </label>
        </div>

      </form>

      <div class="modal-actions">
        <!-- Inline error message spans full width above buttons -->
        <div class="save-error" *ngIf="saveError">{{ saveError }}</div>
        <div class="modal-actions-row">
          <button class="btn btn-cancel" (click)="closeEditModal()">{{ 'profileHeader.cancel' | translate }}</button>
          <button class="btn btn-save" (click)="saveProfile()" [disabled]="isSaving">
            <span *ngIf="!isSaving">{{ 'profileHeader.saveChanges' | translate }}</span>
            <span *ngIf="isSaving">{{ 'profileHeader.saving' | translate }}</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</div>